import React from 'react';
import { Link } from '@tanstack/react-router';
import LogoImage from '@/images/logo.png';
export const Logo = ({ to }) => (<Link to={to} className="flex items-center gap-2">
        <div className="h-9 w-9 grid place-items-center rounded-xl bg-primary/10 text-primary shrink-0">
            <img src={LogoImage} alt="Adora Analytics" className="h-5 w-5"/>
        </div>

        {/* The wordmark is hidden whenever this Logo lives inside a
        collapsed sidebar. shadcn's Sidebar sets `data-collapsible=icon`
        on the .group ancestor, so this CSS selector only fires there
        — the public marketing site (no sidebar wrapper) keeps the full
        wordmark untouched. */}
        <span className="text-lg font-bold tracking-tight group-data-[collapsible=icon]:hidden">
            <span className="bg-linear-to-r from-primary to-primary/60 bg-clip-text text-transparent">Adora</span>
            <span className="text-muted-foreground ml-1">Analytics</span>
        </span>
    </Link>);
Logo.displayName = 'Logo';
